import { apiInstance } from '../client';

export type PostGenerateUploadUrlForContactFormFields = {
  file_type: string;
  email: string;
};

export async function postGenerateUploadUrlForContactForm(
  fields: PostGenerateUploadUrlForContactFormFields
): Promise<any> {
  return await apiInstance.post('/v2/upload/contact-form', fields);
}
